import { render, staticRenderFns } from "./home2.vue?vue&type=template&id=6f961460&scoped=true&"
import script from "./home2.vue?vue&type=script&lang=js&"
export * from "./home2.vue?vue&type=script&lang=js&"
import style1 from "./home2.vue?vue&type=style&index=1&id=6f961460&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f961460",
  null
  
)

export default component.exports